// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2LVHF","location":"Header_location__3c1cm"};